import {
  Badge,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import type { ReportOrderItem } from 'services/interfaces/storeGroupReport';
import { formatCurrency, formatDate, formatPhone } from './reportFormat';

const STATUS_LABEL: Record<string, string> = {
  FIRST_PURCHASE: 'Primeira compra',
  ACCUMULATED: 'Acumulou',
  REDEEMED: 'Resgatou',
};

const STATUS_COLOR: Record<string, string> = {
  FIRST_PURCHASE: 'blue',
  ACCUMULATED: 'yooga',
  REDEEMED: 'green',
};

interface ReportOrdersTableProps {
  data: ReportOrderItem[];
}

const ReportOrdersTable: React.FC<ReportOrdersTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <Text color="gray.500" py="2rem" textAlign="center">
        Nenhum pedido no período.
      </Text>
    );
  }

  return (
    <TableContainer>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Data</Th>
            <Th>Cliente</Th>
            <Th>Loja</Th>
            <Th isNumeric>Total</Th>
            <Th isNumeric>Gerado</Th>
            <Th isNumeric>Resgatado</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row) => (
            <Tr key={row.sale_id}>
              <Td>{formatDate(row.date)}</Td>
              <Td>
                <Text>{row.customer.name}</Text>
                <Text fontSize="xs" color="gray.500">
                  {formatPhone(row.customer.phone)}
                </Text>
              </Td>
              <Td>{row.store?.name ?? '-'}</Td>
              <Td isNumeric>{formatCurrency(row.total)}</Td>
              <Td isNumeric>{formatCurrency(row.generated)}</Td>
              <Td isNumeric>{formatCurrency(row.redeemed)}</Td>
              <Td>
                <Badge colorScheme={STATUS_COLOR[row.status] ?? 'gray'}>
                  {STATUS_LABEL[row.status] ?? row.status}
                </Badge>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default ReportOrdersTable;
